<template>
    <div class="flowPath">
        <div class="top">
            <img src="../image/logo.png" alt="" class="loGo">
            <el-row class="tac">
                <el-col :span="12">
                    <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                        active-text-color="#ffd04b" :unique-opened="true">
                        <el-submenu index="1">
                            <template slot="title">
                                <img src="../image/menu.png" alt="" class="logo-1">
                            </template>
                            <el-menu-item-group>
                                <template v-for="(menu, index) in navList">
                                    <el-menu-item :index="`1-${index + 1}`" v-if="menu.children.length == 0"
                                        :key="menu.index">
                                        <router-link :to="menu.route" class="linkclass">
                                            {{ menu.name }}
                                        </router-link>
                                    </el-menu-item>
                                    <el-submenu :index="`1-${index + 1}`" v-if="menu.children.length !== 0"
                                        :key="menu.index">
                                        <template slot="title">{{ menu.name }}</template>
                                        <el-menu-item v-for="(subMenu, subIndex) in menu.children"
                                            :index="`1-${index + 1}-${subIndex + 1}`" :key="subMenu.index">
                                            <router-link :to="subMenu.route" class="linkclass">{{ subMenu.name
                                            }}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-menu-item-group>

                        </el-submenu>
                    </el-menu>
                </el-col>
            </el-row>
            <!-- <div class="introduce">
                <p class="p1">智如客-专注定制开发</p>
                <p class="p1none" style="display: none;">开发流程</p>
                <p class="p2">Smart Guest - Focus on custom development</p>
                <p class="p2none" style="display: none;">Development Process</p>
            </div> -->
            <div class="links">
                <span class="links-1"><router-link to="/custommall" class="links-1-1">定制开发</router-link></span>
                <span class="links-2">开发流程</span>
            </div>

        </div>
        <div class="develop">
            <div class="develop-1">
                <span>商城定制开发项目交付流程</span>
                <p>智如客为您提供的一对一全程服务</p>
            </div>
            <div class="develop-2">
                <img src="../image/kaiFa.png" alt="">
            </div>
            <button class="btn" @click="toggleDiv">立马开始电商定制开发</button>
            <div class="target-div" v-if="showDiv">
                <div class="target-1">
                    <div class="target-2">
                        <img src="../image/wx.jpg" class="target-2-1">
                        <div class="target-2-2">客服微信</div>
                    </div>
                </div>
            </div>
        </div>
        <BUTTOM></BUTTOM>
    </div>
</template>

<script>
import { api_category } from "@/APi/api";
export default {
    data() {
        return {
            showDiv: false, // 控制div的显示与隐藏
            navList: [],
        };
    },
    methods: {
        toggleDiv() {
            this.showDiv = !this.showDiv; // 点击按钮时切换showDiv的值
        },
        handleScroll() {
            const nav = document.querySelector('.tac'); // 导航栏元素
            const distanceFromTop = nav.offsetTop; // 导航栏距离顶部的距离

            if (window.pageYOffset > distanceFromTop) { // 当滚动距离超过导航栏距离顶部的距离时
                nav.classList.add('fixed'); // 添加固定样式类
            } else {
                nav.classList.remove('fixed'); // 移除固定样式类
            }
        },
        // 获取栏目列表
        getCategory() {
            api_category().then((res) => {
                this.navList = res.data;
                // console.log(this.navList)
            });
        },
    },
    created() {
        this.getCategory();
    },
    mounted() {
        if (!sessionStorage.getItem('isRefreshed')) {
            sessionStorage.setItem('isRefreshed', true);
            window.location.reload();
        } else {
            sessionStorage.removeItem('isRefreshed');
        }
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss" scoped>
// 导航菜单
::v-deep .el-row {
    width: 13rem;
}

::v-deep .el-submenu {
    width: 13rem;
}

::v-deep .el-col-12 {
    width: 100%;
}

::v-deep .el-menu {
    background-color: transparent;
    display: flex;
    flex-direction: column;
}

::v-deep .el-submenu .el-menu-item {
    color: white;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

::v-deep .el-submenu__title {
    color: white;
    background-color: transparent !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

::v-deep .el-icon-arrow-down:before {
    color: white;
}

::v-deep .el-submenu .el-menu-item {
    background-color: transparent !important;
}

::v-deep .el-menu {
    background-color: transparent !important;
}

.tac {
    z-index: 2;
    position: absolute;
    right: 0;
    top: 0;
    background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
}

::v-deep .el-menu-item-group>ul {
    height: 44rem;
}

.tac.fixed {
    position: fixed;
    right: 0;
}

.linkclass {
    text-decoration: none;
    color: white;
}

// 
.top {
    width: 100%;
    height: 15.13rem;
    background-image: url(../image/banner-2.png);
    background-size: 100% 100%;
    margin-bottom: 4.2rem;

    .loGo {
        width: 8.13rem;
        height: 2.51rem;
        margin-left: 5.81rem;
    }

    .logo-1 {
        width: 1.63rem;
        height: 1.63rem;
        margin-right: 5.81rem;
    }

    // .introduce {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     position: absolute;
    //     left: 50%;
    //     transform: translateX(-50%);
    //     top: 7rem;

    //     .p1 {
    //         font-size: 2.25rem;
    //         color: white;
    //     }

    //     .p2 {
    //         font-size: 1.13rem;
    //         color: white;
    //     }
    // }
    .links {
        width: 15rem;
        height: 4.38rem;
        font-size: 1.13rem;
        color: #FFFFFF;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        padding-top: 2rem;
        margin: 0 auto;

        .links-1-1 {
            color: white;
            text-decoration: none;
        }

        .links-2 {
            background-color: white;
            color: #014F93;
        }

        span {
            width: 7.13rem;
            height: 4.38rem;
            text-align: center;
            line-height: 4.38rem;
            cursor: pointer;
            cursor: zoom-in;
            transition: font-size 0.2s ease-in-out;
        }

        span:hover {
            font-size: 1.2em;
            cursor: pointer;
        }
    }
}

// 

.develop {
    width: 100%;
    height: 100rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .develop-1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1.56rem;

        span {
            font-size: 1.88rem;
            margin-bottom: 0.75rem;
        }

        p {
            font-size: 0.88rem;
            color: #999999;
        }
    }

    .develop-2 {
        width: 100%;
        display: flex;
        background-color: #3a8ee6;
        flex-direction: column;
        align-items: center;
        height: 74.3rem;

        img {
            width: 75.25rem;
            height: 79.25rem;
            margin-top: -0.7rem;
        }
    }

    .btn {
        width: 16.44rem;
        height: 3.75rem;
        border-radius: 0.5rem;
        border: 0.06rem solid #014F93;
        font-size: 1.13rem;
        color: #014F93;
        margin-top: 5rem;
        cursor: pointer
    }

    .target-div {
        margin-left: 30rem;
        margin-top: -4rem;

        .target-1 {
            width: 11.5rem;
            height: 11rem;
            background-image: url(../image/danC.png);
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .target-2 {
                width: 5.88rem;
                height: 8rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                .target-2-1 {
                    width: 100%;
                    height: 5.88rem;
                    background-color: pink;
                }

                .target-2-2 {
                    font-size: 0.88rem;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #014F93;
                }
            }
        }
    }


}

// 移动端
@media screen and (max-width: 900px) {

    // 移动
    ::v-deep .el-row {
        width: 13rem;
    }

    ::v-deep .el-row {
        width: 13rem;
    }

    ::v-deep .el-submenu {
        width: 100%;
    }

    ::v-deep .el-col-12 {
        width: 100%;
    }

    ::v-deep .el-menu {
        background-color: transparent;
        display: flex;
        flex-direction: column;
    }

    ::v-deep .el-submenu .el-menu-item {
        color: white;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    ::v-deep .el-submenu__title {
        color: white;
        background-color: transparent !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 8.5rem;
    }

    ::v-deep .el-icon-arrow-down:before {
        color: white;
    }

    ::v-deep .el-submenu .el-menu-item {
        background-color: transparent !important;
    }

    ::v-deep .el-menu {
        background-color: transparent !important;
    }

    .tac {
        width: 35%;
        z-index: 2;
        position: absolute;
        right: 0;
        top: 0;
        background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
    }

    ::v-deep .el-menu-item-group>ul {
        height: 49rem;
    }

    .tac.fixed {
        position: fixed;
        right: 0;
    }

    .linkclass {
        text-decoration: none;
        color: white;
    }

    // 
    .top {
        width: 100%;
        height: 15.13rem;
        background-image: url(../image/banner-2.png);
        background-size: 100% 100%;
        margin-bottom: 4.2rem;

        .loGo {
            width: 8.13rem;
            height: 2.51rem;
            margin-left: 0rem;
            margin-top: 0.5rem;
        }

        .logo-1 {
            width: 1.63rem;
            height: 1.63rem;
            margin-right: 5.81rem;
        }

        // .introduce {
        //     display: flex;
        //     flex-direction: column;
        //     align-items: center;
        //     position: absolute;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     top: 7rem;

        //     .p1 {
        //         display: none;
        //         font-size: 2.25rem;
        //         color: white;
        //     }

        //     .p1none {
        //         display: block !important;
        //         font-size: 2.25rem;
        //         color: white;
        //     }

        //     .p2 {
        //         display: none;
        //         font-size: 1.13rem;
        //         color: white;
        //     }

        //     .p2none {
        //         display: block !important;
        //         font-size: 1.13rem;
        //         color: white;
        //     }
        // }
        .links {
            width: 15rem;
            height: 4.38rem;
            font-size: 1.13rem;
            color: #FFFFFF;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
            padding-top: 2rem;
            margin: 0 auto;

            .links-1-1 {
                color: white;
                text-decoration: none;
            }

            .links-2 {
                background-color: white;
                color: #014F93;
            }

            span {
                width: 7.13rem;
                height: 4.38rem;
                text-align: center;
                line-height: 4.38rem;
                cursor: pointer;
                cursor: zoom-in;
                transition: font-size 0.2s ease-in-out;
            }

            span:hover {
                font-size: 1.2em;
                cursor: pointer;
            }
        }
    }

    // 

    .develop {
        width: 100%;
        height: 70rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .develop-1 {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 1.56rem;

            span {
                font-size: 1.2rem;
                font-weight: 600;
                margin-bottom: 0.75rem;
            }

            p {
                font-size: 0.88rem;
                color: #999999;
            }
        }

        .develop-2 {
            width: 100%;
            display: flex;
            background-color: #3a8ee6;
            flex-direction: column;
            align-items: center;
            height: 40rem;

            img {
                width: 100%;
                height: 41rem;
                margin-top: -0.7rem;
            }
        }

        .btn {
            width: 16.44rem;
            height: 3.75rem;
            border-radius: 0.5rem;
            border: 0.06rem solid #014F93;
            font-size: 1.13rem;
            color: #014F93;
            margin-top: 5rem;
            cursor: pointer
        }

        .target-div {
            margin-left: 0rem;
            margin-top: 1rem;

            .target-1 {
                width: 11.5rem;
                height: 11rem;
                background-image: url(../image/danC.png);
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                .target-2 {
                    width: 5.88rem;
                    height: 8rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;

                    .target-2-1 {
                        width: 100%;
                        height: 5.88rem;
                        background-color: pink;
                    }

                    .target-2-2 {
                        font-size: 0.88rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #014F93;
                    }
                }
            }
        }


    }
}
</style>